import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { showSuccess, showError, showLoading, hideLoading, clearPedidos } from '../../actions';
import { bindActionCreators } from 'redux';
import { getFavoritos, getFornecedores, salvaFavoritos } from '../../services/APIService';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';
import { getUserData } from '../../utils/Services';

const FormFaccoes = (props) => {
    const [faccoesOptions, setFaccoesOptions] = useState([]);
    const [faccoes, setFaccoes] = useState([]);

    useEffect(() => {
        async function fetch() {
            const data = await getFornecedores('');
            const options = data.map(e => ({
                value: e.codFornecedor,
                label: e.nome,
            }));
            const favoritos = await getFavoritos(getUserData().login);
            const result = [];
            if (favoritos.data && favoritos.data.length > 0) {
                options.forEach((x) => {
                    if (!favoritos.data.some(y => y.value === x.value)) {
                        result.push({value: x.value, label: x.label});
                    }
                })

            } else {
                options.forEach((x) => {
                    result.push({value: x.value, label: x.label});
                })
            }

            setFaccoesOptions(result);
        }
        fetch();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    const closeModal = () => {
        props.closeModal();
    };

    const salvar = async () => {
        props.showLoading();
        const favoritos = await getFavoritos(getUserData().login);
        
        let tmpArr = [];
        if (favoritos.data && favoritos.data.length > 0) {
            tmpArr = faccoes.concat(favoritos.data);
        } else {
            tmpArr = faccoes;
        }
        const uniqueArr = Array.from(new Set(tmpArr.map(a => a.value))).map(id => {
            return tmpArr.find(a => a.value === id)
        })

        await salvaFavoritos(getUserData().login, uniqueArr);
        props.clearPedidos();
        setFaccoes([]);
        props.hideLoading();
        props.closeModal();
        props.carregaFavoritos();
    };

    return (
        <Modal isOpen={props.showModal} toggle={closeModal} className='modal-xl mw-70 w-90'>
            <ModalHeader className='modal-title' toggle={closeModal} >Adicionar Facções</ModalHeader>
            <ModalBody className=''>
                <Select
                    isMulti
                    isRequired
                    isClearable
                    isSearchable
                    inputId='faccoes'
                    onChange={(e) => setFaccoes(e)}
                    value={faccoes}
                    options={faccoesOptions}
                    placeholder='Escolha as Facções'
                />
            </ModalBody>
            <ModalFooter>
                <Button type='submit' size='md' color='primary' onClick={salvar}>
                    <i className='fa fa-plus'></i>
                    {
                        faccoes && faccoes.length > 0 ? ` Adicionar as ${faccoes.length} facções` :
                        ` Adicionar facção`
                    }
                </Button>
            </ModalFooter>
        </Modal>
    );
};

const mapStateToProps = (store) => ({});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            showSuccess,
            showError,
            showLoading,
            hideLoading,
            clearPedidos,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(FormFaccoes);
